module.exports = __webpack_public_path__ + "static/media/share-icon-pet.079c8650.svg";